/*
  Marianne Mode — thema-scripts (eigen code, zonder externe bibliotheken)
*/
(function () {
  'use strict';

  var mqDesktop = window.matchMedia('(min-width: 769px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function pubsub() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        return { subscribe: subscribe, events: PUB_SUB_EVENTS };
      }
    } catch (e) { /* niet beschikbaar */ }
    return null;
  }
  function onSectionLoad(cb) {
    document.addEventListener('shopify:section:load', function (e) { cb(e.target); });
  }

  /* ---------- Overlay en lades ---------- */
  var overlay = null;
  var openDrawerEl = null;
  var lastFocus = null;

  function getOverlay() {
    if (!overlay) overlay = $('[data-mm-overlay]');
    return overlay;
  }

  function openDrawer(id, trigger) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    if (openDrawerEl && openDrawerEl !== drawer) closeDrawer();
    lastFocus = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    $$('[data-mm-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var ov = getOverlay();
    if (ov) ov.classList.add('is-visible');
    document.body.classList.add('mm-lock');
    openDrawerEl = drawer;
    var focusTarget = drawer.querySelector('[data-mm-drawer-close]');
    if (focusTarget) setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 50);
  }

  function closeDrawer() {
    if (!openDrawerEl) return;
    var id = openDrawerEl.id;
    openDrawerEl.classList.remove('is-open');
    openDrawerEl.setAttribute('aria-hidden', 'true');
    $$('[data-mm-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var ov = getOverlay();
    if (ov) ov.classList.remove('is-visible');
    document.body.classList.remove('mm-lock');
    openDrawerEl = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mm-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-mm-drawer-open'), opener);
      return;
    }
    if (e.target.closest('[data-mm-drawer-close]') || e.target.closest('[data-mm-overlay]')) {
      closeDrawer();
      closeSearch();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeSearch();
      closeLightbox();
    }
  });

  /* ---------- Uitklappers (menu, FAQ, tabs, filters) ---------- */
  function setCollapsible(trigger, open, animate) {
    var id = trigger.getAttribute('aria-controls');
    var panel = id ? document.getElementById(id) : null;
    if (!panel) return;
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    trigger.classList.toggle('is-open', open);

    // Eenvoudige lijsten (menu) wisselen alleen een klasse
    if (!panel.classList.contains('mm-collapsible-content')) {
      panel.classList.toggle('is-open', open);
      return;
    }

    if (!animate || reduceMotion) {
      panel.classList.toggle('is-open', open);
      panel.style.height = open ? 'auto' : '';
      return;
    }

    var inner = panel.firstElementChild;
    var target = inner ? inner.scrollHeight : panel.scrollHeight;
    if (open) {
      panel.style.height = '0px';
      panel.classList.add('is-open');
      requestAnimationFrame(function () {
        panel.style.height = target + 'px';
      });
      var done = function () {
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', done);
      };
      panel.addEventListener('transitionend', done);
    } else {
      panel.style.height = panel.offsetHeight + 'px';
      requestAnimationFrame(function () {
        panel.classList.remove('is-open');
        panel.style.height = '0px';
      });
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mm-collapsible], [data-mm-collapse]');
    if (!trigger) return;
    e.preventDefault();
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    setCollapsible(trigger, !isOpen, true);
  });

  function initCollapsibles(root) {
    $$('[data-mm-collapsible][aria-expanded="true"]', root).forEach(function (t) {
      var id = t.getAttribute('aria-controls');
      var panel = id && document.getElementById(id);
      if (panel) { panel.classList.add('is-open'); panel.style.height = 'auto'; }
    });
  }

  /* ---------- Footer (mobiel uitklapbaar) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mm-footer-toggle]');
    if (!btn || mqDesktop.matches) return;
    var content = btn.closest('.mm-footer__section').querySelector('.mm-footer__collapsible');
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (content) content.classList.toggle('is-open', open);
  });

  /* ---------- Zoeken in header ---------- */
  var searchEl = null;
  function openSearch() {
    searchEl = searchEl || $('[data-mm-search]');
    if (!searchEl) return false;
    searchEl.classList.add('is-active');
    var input = searchEl.querySelector('input[type="search"]');
    if (input) setTimeout(function () { input.focus(); }, 30);
    var ov = getOverlay();
    if (ov) ov.classList.add('is-visible');
    return true;
  }
  function closeSearch() {
    if (!searchEl || !searchEl.classList.contains('is-active')) return;
    searchEl.classList.remove('is-active');
    if (!openDrawerEl) {
      var ov = getOverlay();
      if (ov) ov.classList.remove('is-visible');
    }
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mm-search-open]');
    if (opener) {
      if (openSearch()) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-mm-search-close]')) {
      e.preventDefault();
      closeSearch();
    }
  });

  /* ---------- Aankondigingsbalk ---------- */
  function initAnnouncement(root) {
    $$('[data-mm-announcement]', root).forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var slides = $$('.mm-announcement__slide', bar);
      if (slides.length < 2) return;
      var i = 0;
      var speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
      var paused = false;
      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused || document.hidden) return;
        var current = slides[i];
        i = (i + 1) % slides.length;
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        setTimeout(function () { current.classList.remove('is-leaving'); }, 500);
        slides[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- Afbeeldingen laten invagen ---------- */
  function initFade(root) {
    $$('img.mm-fade-img', root).forEach(function (img) {
      if (img.complete) img.classList.add('is-loaded');
      else img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    });
  }

  /* ---------- Parallax ---------- */
  var parallaxItems = [];
  function initParallax(root) {
    $$('[data-mm-parallax]', root).forEach(function (container) {
      $$('[data-mm-parallax-image]', container).forEach(function (img) {
        if (img.dataset.ready) return;
        img.dataset.ready = '1';
        parallaxItems.push({ container: container, img: img });
      });
    });
    updateParallax();
  }
  var parallaxTicking = false;
  function updateParallax() {
    parallaxTicking = false;
    if (!mqDesktop.matches || reduceMotion) {
      parallaxItems.forEach(function (p) { p.img.style.transform = ''; });
      return;
    }
    var vh = window.innerHeight;
    parallaxItems.forEach(function (p) {
      if (!p.container.isConnected) return;
      var rect = p.container.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return;
      var shift = (-rect.top) * 0.15;
      p.img.style.transform = 'translate3d(0,' + shift.toFixed(1) + 'px,0)';
    });
  }
  window.addEventListener('scroll', function () {
    if (!parallaxItems.length || parallaxTicking) return;
    parallaxTicking = true;
    requestAnimationFrame(updateParallax);
  }, { passive: true });
  window.addEventListener('resize', debounce(updateParallax, 150));

  /* ---------- Slideshow (hero) ---------- */
  function initSlideshow(root) {
    $$('[data-mm-slideshow]', root).forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var slides = $$('.mm-hero__slide', el);
      var dots = $$('.mm-hero__dot', el);
      if (slides.length < 2) return;
      var index = 0;
      var timer = null;
      var autoplay = el.dataset.autoplay === 'true';
      var speed = parseInt(el.dataset.speed, 10) || 7000;

      function go(n) {
        index = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) {
          d.classList.remove('is-active');
          if (i === index) { void d.offsetWidth; d.classList.add('is-active'); }
        });
      }
      function start() {
        if (!autoplay) return;
        stop();
        timer = setInterval(function () { go(index + 1); }, speed);
      }
      function stop() { if (timer) clearInterval(timer); timer = null; }

      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); start(); }); });
      var prev = el.querySelector('[data-mm-prev]');
      var next = el.querySelector('[data-mm-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
      if (next) next.addEventListener('click', function () { go(index + 1); start(); });

      var startX = null;
      el.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) { go(dx < 0 ? index + 1 : index - 1); start(); }
        startX = null;
      }, { passive: true });

      el.addEventListener('shopify:block:select', function (e) {
        var s = e.target.closest('.mm-hero__slide');
        if (s) { stop(); go(slides.indexOf(s)); }
      });
      el.addEventListener('shopify:block:deselect', start);
      start();
    });
  }

  /* ---------- Reviews-carrousel ---------- */
  function initTestimonials(root) {
    $$('[data-mm-testimonials]', root).forEach(function (section) {
      if (section.dataset.ready) return;
      var viewport = section.querySelector('[data-mm-testimonials-viewport]');
      var track = section.querySelector('[data-mm-testimonials-track]');
      if (!viewport || !track) return;
      section.dataset.ready = '1';
      var slides = $$('.mm-testimonials__slide', track);
      var dots = $$('[data-mm-testimonials-dots] button', section);
      var n = slides.length;
      if (!n) return;
      var wrap = n > 3;
      var index = 0;

      track.style.display = 'block';
      track.style.position = 'relative';
      slides.forEach(function (s) {
        s.style.position = 'absolute';
        s.style.top = '0';
        s.style.left = '0';
      });

      function slideWidth() { return mqDesktop.matches ? viewport.clientWidth * 0.33 : viewport.clientWidth; }

      function offsetFor(i) {
        var o = i - index;
        if (wrap) {
          var half = Math.floor(n / 2);
          o = ((o + n + half) % n) - half;
        }
        return o;
      }

      var prevOffsets = [];
      function layout(animate) {
        var w = slideWidth();
        var center = (viewport.clientWidth - w) / 2;
        var maxH = 0;
        slides.forEach(function (s, i) {
          s.style.width = w + 'px';
          var o = offsetFor(i);
          var jump = prevOffsets[i] !== undefined && Math.abs(prevOffsets[i] - o) > 1;
          s.style.transition = (!animate || jump) ? 'none' : 'transform 0.5s cubic-bezier(0.25,0.46,0.45,0.94)';
          s.style.transform = 'translateX(' + (center + o * w) + 'px)';
          s.classList.toggle('is-selected', i === index);
          s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
          prevOffsets[i] = o;
          if (s.offsetHeight > maxH) maxH = s.offsetHeight;
        });
        track.style.height = maxH + 'px';
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }

      function go(i) {
        index = wrap ? (i + n) % n : Math.max(0, Math.min(n - 1, i));
        layout(true);
      }

      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      slides.forEach(function (s, i) {
        s.addEventListener('click', function () { if (i !== index) go(i); });
      });

      var startX = null;
      viewport.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(dx < 0 ? index + 1 : index - 1);
        startX = null;
      }, { passive: true });

      var mouseX = null;
      viewport.addEventListener('mousedown', function (e) { mouseX = e.clientX; });
      viewport.addEventListener('mouseup', function (e) {
        if (mouseX === null) return;
        var dx = e.clientX - mouseX;
        if (Math.abs(dx) > 40) go(dx < 0 ? index + 1 : index - 1);
        mouseX = null;
      });

      layout(false);
      $$('img', track).forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () { layout(false); }, { once: true });
      });
      window.addEventListener('resize', debounce(function () { layout(false); }, 150));

      // Na een seconde naar de tweede review schuiven (laat zien dat er meer zijn)
      if (n > 2) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              setTimeout(function () { if (index === 0) go(1); }, 1000);
              io.disconnect();
            }
          });
        }, { rootMargin: '0px 0px -100px 0px' });
        io.observe(section);
      }

      section.addEventListener('shopify:block:select', function (e) {
        var s = e.target.closest('.mm-testimonials__slide');
        if (s) go(slides.indexOf(s));
      });
    });
  }

  /* ---------- Productgalerij ---------- */
  var activeLightbox = null;
  function closeLightbox() {
    if (!activeLightbox) return;
    activeLightbox.el.classList.remove('is-open');
    document.body.classList.remove('mm-lock');
    activeLightbox = null;
  }

  function initGallery(root) {
    $$('[data-mm-gallery]', root).forEach(function (gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = '1';
      var viewport = gallery.querySelector('[data-mm-gallery-viewport]');
      if (!viewport) return;
      var slides = $$('.mm-gallery__slide', viewport);
      var thumbs = $$('.mm-gallery__thumb', gallery);
      var dots = $$('[data-mm-gallery-dots] button', gallery);
      var thumbScroller = gallery.querySelector('[data-mm-gallery-thumbs]');
      var current = 0;
      var n = slides.length;

      // Eindeloos doorscrollen: kopie van de laatste foto vóór de eerste en van de eerste ná de laatste
      var loop = false; // eindeloos doorscrollen uitgeschakeld
      var allSlides = slides.slice();
      if (loop) {
        var makeClone = function (src, realIndex) {
          var c = src.cloneNode(true);
          c.classList.add('is-clone');
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-media-id');
          c.dataset.cloneOf = realIndex;
          $$('[id]', c).forEach(function (el) { el.removeAttribute('id'); });
          $$('button, a, video, iframe', c).forEach(function (el) { el.setAttribute('tabindex', '-1'); });
          $$('img', c).forEach(function (img) { img.setAttribute('loading', 'eager'); });
          return c;
        };
        var headClone = makeClone(slides[n - 1], n - 1);
        var tailClone = makeClone(slides[0], 0);
        viewport.insertBefore(headClone, slides[0]);
        viewport.appendChild(tailClone);
        allSlides = [headClone].concat(slides, [tailClone]);
      }

      function leftFor(slide) {
        var left = slide.offsetLeft - viewport.offsetLeft;
        if (!mqDesktop.matches && gallery.classList.contains('mm-gallery--partial')) {
          left = slide.offsetLeft - viewport.offsetLeft - (viewport.clientWidth - slide.clientWidth) / 2;
          if (slide === slides[0]) left = 0;
        }
        return Math.max(0, left);
      }

      function jumpTo(slide) {
        var prev = viewport.style.scrollBehavior;
        viewport.style.scrollBehavior = 'auto';
        viewport.scrollLeft = leftFor(slide);
        viewport.style.scrollBehavior = prev;
      }

      function setActive(i) {
        current = i;
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        var thumb = thumbs[i];
        if (thumb && thumbScroller) {
          var vertical = getComputedStyle(thumbScroller).position === 'absolute';
          if (vertical) {
            var top = thumb.offsetTop - thumbScroller.clientHeight / 2 + thumb.offsetHeight / 2;
            thumbScroller.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          } else {
            var left = thumb.offsetLeft - thumbScroller.clientWidth / 2 + thumb.offsetWidth / 2;
            thumbScroller.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        }
        slides.forEach(function (s, k) {
          if (k !== i) {
            var v = s.querySelector('video');
            if (v && !v.paused) v.pause();
          }
        });
      }

      // i mag -1 (kopie vóór de eerste) of n (kopie ná de laatste) zijn
      function goTo(i, smooth) {
        var slide;
        if (loop && i < 0) slide = allSlides[0];
        else if (loop && i >= n) slide = allSlides[allSlides.length - 1];
        else slide = slides[i];
        if (!slide) return;
        if (smooth === false) jumpTo(slide);
        else viewport.scrollTo({ left: leftFor(slide), behavior: 'smooth' });
        setActive(((i % n) + n) % n);
      }

      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

      var scrollTimer;
      viewport.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          if (dragX !== null) return;
          var center = viewport.scrollLeft + viewport.clientWidth / 2;
          var bestEl = null, bestDist = Infinity;
          allSlides.forEach(function (sl) {
            var c = sl.offsetLeft - viewport.offsetLeft + sl.clientWidth / 2;
            var dist = Math.abs(c - center);
            if (dist < bestDist) { bestDist = dist; bestEl = sl; }
          });
          if (!bestEl) return;
          if (bestEl.classList.contains('is-clone')) {
            var real = parseInt(bestEl.dataset.cloneOf, 10) || 0;
            jumpTo(slides[real]);
            setActive(real);
            return;
          }
          var best = slides.indexOf(bestEl);
          if (best !== current) setActive(best);
        }, 90);
      }, { passive: true });

      // Desktop: slepen met de muis
      var dragX = null, dragLeft = 0, dragged = false;
      viewport.addEventListener('mousedown', function (e) {
        if (!mqDesktop.matches) return;
        dragX = e.clientX; dragLeft = viewport.scrollLeft; dragged = false;
        viewport.style.scrollSnapType = 'none';
        viewport.style.scrollBehavior = 'auto';
      });
      window.addEventListener('mousemove', function (e) {
        if (dragX === null) return;
        var dx = e.clientX - dragX;
        if (Math.abs(dx) > 5) dragged = true;
        viewport.scrollLeft = dragLeft - dx;
      });
      window.addEventListener('mouseup', function (e) {
        if (dragX === null) return;
        var dx = e.clientX - dragX;
        dragX = null;
        viewport.style.scrollSnapType = '';
        viewport.style.scrollBehavior = '';
        if (dragged) {
          var target = current;
          if (dx < -40) target = loop ? current + 1 : Math.min(n - 1, current + 1);
          if (dx > 40) target = loop ? current - 1 : Math.max(0, current - 1);
          goTo(target);
        }
      });
      viewport.addEventListener('click', function (e) {
        if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
      }, true);

      // Startafbeelding (geselecteerde variant)
      var initial = parseInt(gallery.dataset.initial, 10) || 0;
      if (initial > 0 || loop) requestAnimationFrame(function () { goTo(initial, false); });
      window.addEventListener('resize', debounce(function () { if (slides[current]) jumpTo(slides[current]); }, 150));

      // Variant wisselt → bijbehorende afbeelding tonen
      var ps = pubsub();
      if (ps) {
        ps.subscribe(ps.events.variantChange, function (event) {
          var data = event && event.data;
          if (!data || !data.variant || !data.variant.featured_media) return;
          if (data.sectionId !== gallery.dataset.section) return;
          var id = gallery.dataset.section + '-' + data.variant.featured_media.id;
          slides.forEach(function (s, k) {
            if (s.getAttribute('data-media-id') === id) goTo(k);
          });
        });
      }

      // Lichtbak
      var lightbox = document.getElementById('MmLightbox-' + gallery.dataset.section);
      if (lightbox && gallery.dataset.zoom === 'true') {
        var lbImg = lightbox.querySelector('[data-mm-lightbox-img]');
        var tpl = lightbox.querySelector('[data-mm-lightbox-sources]');
        var sources = tpl ? $$('span', tpl.content) : [];
        var lbIndex = 0;
        var showLb = function (mediaIndex) {
          var srcIdx = 0;
          sources.forEach(function (s, k) { if (parseInt(s.dataset.index, 10) === mediaIndex) srcIdx = k; });
          lbIndex = srcIdx;
          var s = sources[srcIdx];
          if (!s) return;
          lbImg.src = s.dataset.src;
          lbImg.alt = s.dataset.alt || '';
        };
        var openLb = function (mediaIndex) {
          if (!sources.length) return;
          showLb(mediaIndex);
          lightbox.classList.add('is-open');
          document.body.classList.add('mm-lock');
          activeLightbox = { el: lightbox };
          lightbox.scrollTop = 0;
        };
        $$('[data-mm-zoom]', gallery).forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (dragged) return;
            openLb(parseInt(btn.getAttribute('data-mm-zoom'), 10) || 0);
          });
        });
        var zoomBtn = gallery.querySelector('[data-mm-zoom-current]');
        if (zoomBtn) zoomBtn.addEventListener('click', function () { openLb(current); });
        lbImg.addEventListener('click', closeLightbox);
        var closeBtn = lightbox.querySelector('[data-mm-lightbox-close]');
        if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
        var prevBtn = lightbox.querySelector('[data-mm-lightbox-prev]');
        var nextBtn = lightbox.querySelector('[data-mm-lightbox-next]');
        var step = function (d) {
          lbIndex = (lbIndex + d + sources.length) % sources.length;
          lbImg.src = sources[lbIndex].dataset.src;
          lbImg.alt = sources[lbIndex].dataset.alt || '';
        };
        if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
        // lichtbak buiten de sectie plaatsen zodat 'fixed' altijd werkt
        if (lightbox.parentElement !== document.body) {
          $$('body > #' + lightbox.id).forEach(function (old) { if (old !== lightbox) old.remove(); });
          document.body.appendChild(lightbox);
        }
      }
    });
  }

  /* ---------- Recent bekeken ---------- */
  var RV_KEY = 'mm-recently-viewed';
  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]') || []; } catch (e) { return []; }
  }
  function writeRecent(list) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) { /* opslag niet beschikbaar */ }
  }
  function trackProduct() {
    var product = $('[data-mm-product]');
    if (!product) return;
    var handle = product.getAttribute('data-product-handle');
    if (!handle) return;
    var list = readRecent().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    writeRecent(list);
  }
  function initRecentlyViewed(root) {
    $$('[data-mm-recently-viewed]', root).forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var grid = wrap.querySelector('[data-mm-recently-viewed-grid]');
      var limit = parseInt(wrap.dataset.limit, 10) || 5;
      var current = wrap.dataset.current;
      var handles = readRecent().filter(function (h) { return h && h !== current; }).slice(0, limit);
      if (!handles.length || !grid) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      Promise.all(handles.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=' + wrap.dataset.cardSection)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (htmls) {
        var count = 0;
        htmls.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('.mm-card');
          if (card) { grid.appendChild(card); count++; }
        });
        if (count) wrap.hidden = false;
      });
    });
  }

  /* ---------- Productaanbevelingen ---------- */
  function initRecommendations(root) {
    $$('[data-mm-recommendations]', root).forEach(function (el) {
      if (el.dataset.ready || el.querySelector('.mm-card')) return;
      el.dataset.ready = '1';
      var load = function () {
        fetch(el.dataset.url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var fresh = doc.querySelector('[data-mm-recommendations]');
            if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      };
      // direct laden (een leeg element wordt door Dawn verborgen, dus niet wachten op zichtbaarheid)
      if ('requestIdleCallback' in window) window.requestIdleCallback(load, { timeout: 1500 });
      else setTimeout(load, 200);
    });
  }


  /* ---------- Swatches op productkaarten ---------- */
  function swapCardImage(swatch, card) {
    var img = card.querySelector('[data-mm-card-image]');
    if (!img || !swatch.dataset.img) return;
    if (!img.dataset.origSrc) {
      img.dataset.origSrc = img.getAttribute('src') || '';
      img.dataset.origSrcset = img.getAttribute('srcset') || '';
    }
    img.setAttribute('src', swatch.dataset.img);
    if (swatch.dataset.srcset) img.setAttribute('srcset', swatch.dataset.srcset);
    card.querySelectorAll('.mm-card-swatches__item').forEach(function (s) { s.classList.toggle('is-active', s === swatch); });
    // links naar de gekozen variant laten wijzen
    card.querySelectorAll('[data-mm-card-link]').forEach(function (a) { a.setAttribute('href', swatch.getAttribute('href')); });
  }
  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest('.mm-card-swatches__item');
    if (!swatch || !window.matchMedia('(hover: hover)').matches) return;
    var card = swatch.closest('[data-mm-card]');
    if (card) swapCardImage(swatch, card);
  });

  /* ---------- Filters: automatisch versturen ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-mm-autosubmit]');
    if (!el) return;
    var form = el.form || el.closest('form');
    if (!form) return;
    var params = new URLSearchParams(new FormData(form));
    var clean = new URLSearchParams();
    params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
    window.location.href = form.getAttribute('action') + (clean.toString() ? '?' + clean.toString() : '');
  });

  /* ---------- Opstarten ---------- */
  function initAll(root) {
    initAnnouncement(root);
    initCollapsibles(root);
    initFade(root);
    initParallax(root);
    initSlideshow(root);
    initTestimonials(root);
    initGallery(root);
    initRecentlyViewed(root);
    initRecommendations(root);
  }

  function boot() {
    trackProduct();
    initAll(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  onSectionLoad(function (target) { initAll(target); });

  // Na het verversen van de productsectie door Dawn (variantwissel) opnieuw koppelen
  document.addEventListener('product-info:loaded', function (e) { initGallery(e.target); initCollapsibles(e.target); });

  // Dawn/Upcart: winkelwagen-stip bijwerken na toevoegen
  function refreshCartDot() {
    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('.mm-cart-link__dot').forEach(function (dot) {
          dot.classList.toggle('is-visible', cart.item_count > 0);
          
        });
      })
      .catch(function () {});
  }
  var cartPs = pubsub();
  if (cartPs) cartPs.subscribe(cartPs.events.cartUpdate, refreshCartDot);
  document.addEventListener('cart:updated', refreshCartDot);
  document.addEventListener('cart:refresh', refreshCartDot);

  window.MarianneMode = { openDrawer: openDrawer, closeDrawer: closeDrawer, refreshCartDot: refreshCartDot };
})();
